<template>
    <div id="navigation">
        <ul class="nav justify-content-center">
            <template v-for="item in navItems" :key="item">
                <template v-if="navItems.length">
                    <router-link v-if="item !== 'reports'" :to="{ name: item }" custom
                        v-slot="{ href, navigate, isActive }">
                        <li>
                            <a :class="{ active: isActive }" :href="href" @click="navigate"
                                class="nav-link text-white fw-medium px-0 mx-2">
                                {{ $t('nav.' + item) }}
                            </a>
                        </li>
                    </router-link>
                    <li v-else-if="item === 'reports'" @mouseleave="() => { if (!isMobile) showReportsNav = false }" v-on-click-outside="reportsClose"
                        @mouseover="() => { if (!isMobile) showReportsNav = true }">
                        <a :class="{ active: isReportsActive, 'show-reports': showReportsNav }"
                            @click="showReportsNav = !showReportsNav" class="nav-link text-white fw-medium px-0 mx-2"
                            style="cursor:pointer;">
                            {{ $t('nav.' + item) }}
                        </a>
                        <div v-if="showReportsNav" class="filter-dropdown_items">
                            <ul>
                                <li v-for="report in reports" :key="report.name" :class="{ 'filter-dropdown_item': true }"
                                    class="px-3 py-2 d-flex justify-content-between align-items-center"
                                    @click="() => { $router.push({ name: report.name }); showReportsNav = false }">
                                    <span>{{ $t('nav.' + report.name) }}</span>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <template v-if="config?.extra_nav_items && config?.extra_nav_items.length">
                        <li v-for="item in config.extra_nav_items" :key="item">
                            <a :href="item.href" :target="item.target"
                                class="nav-link text-white fw-medium px-0 mx-2">
                                {{ $t('nav.' + item.name) }}
                            </a>
                        </li>
                    </template>
                </template>
            </template>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { unauthorizedNav, webMasterNav, touroperatorNav, clientNav } from '@/config/header-nav.js'
import screenMixin from '@/mixins/screen'
import { vOnClickOutside } from '@vueuse/components'

export default {
    name: 'AppNav',
    directives: {
        onClickOutside: vOnClickOutside
    },
    components: {

    },
    computed: {
        ...mapState({
            user: state => state.users.user,
            config: state => state.config
        }),
        navItems() {
            const roleNavMap = {
                admin: touroperatorNav,
                webmaster: webMasterNav,
                client: clientNav,
                unauthorized: unauthorizedNav
            };
            return roleNavMap[this.user.type];
        },
        isReportsActive() {
            return this.reports.some(report => this.$route.name === report.name);
        }
    },
    data() {
        return {
            isMobile: false,
            showReportsNav: false,
            reports: [
                { name: 'spoListReport' },
                { name: 'spoPriceReport' },
                { name: 'stopsaleReport' }
            ]
        }
    },
    methods: {
        reportsClose(){
            this.showReportsNav = false;
        }
    },
    mixins: [
        screenMixin
    ],
    beforeMount() {
        const self = this;
        window.addEventListener('resize', function () {
            self.isMobile = self.isBreakpoint('xs');
        });
        self.isMobile = self.isBreakpoint('xs');
    },
    created() {
        this.$watch(
            () => this.$route,
            () => {
                this.$store.dispatch('stopsale/clearResult')
                this.showReportsNav = false
            },
            {
                immediate: true
            }
        );
    },
}
</script>

<style scoped>
.nav-link.show-reports::after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
}

.filter-dropdown_item.active {
    background: var(--bs-primary) !important;
    color: var(--bs-white) !important;
}

.nav-link {
    transition: border-bottom-color .2s;
    border-bottom: 3px solid transparent;
}

.nav-link.active,
.nav-link:hover {
    border-bottom-color: #fff;
}

.filter-dropdown_items {
    background: #fff;
    position: absolute;
    top: 100%;
    left: calc(50% - 90px);
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: auto;
    min-width: 180px;
    max-width: 300px;
    width: auto;
    z-index: 1;
}

li {
    position: relative;
}

.filter-dropdown_items ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.filter-dropdown_items li {
    font-size: 14px;
    line-height: 1.5;
    padding: 10px 15px;
}


.filter-dropdown_item {
    border-bottom: 1px solid rgba(255, 255, 255, .1);
    cursor: pointer;
    font-size: 16px;
    line-height: 1.5;
    padding: 10px;
}

.filter-dropdown_item:hover {
    background: var(--bs-primary) !important;
    color: var(--bs-white) !important;
}

.filter-dropdown_item:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, .06);
}
</style>
